import { common, getIdentityUid } from '@/common';
import { storage } from '@/utils/storage';

const STORAGE_KEY = 'float_tagline_hidden_until';

function scopeKey(): string {
  const uid = getIdentityUid() || 'anonymous';
  const tenant = common.tenantCode?.trim() || 'default';
  return `${STORAGE_KEY}:${tenant}:${uid}`;
}

export function getTaglineHiddenUntil(): number | null {
  return storage.get<number>(scopeKey());
}

export function isTaglineDismissed(): boolean {
  const until = getTaglineHiddenUntil();
  if (!until) return false;
  if (Date.now() >= until) {
    storage.remove(scopeKey());
    return false;
  }
  return true;
}

export function dismissTaglineForDays(days: number): void {
  const until = Date.now() + days * 24 * 60 * 60 * 1000;
  storage.set(scopeKey(), until);
}
